// import { useRouter } from "next/router";
import React from "react";
// import { useNavigate } from 'react-router-dom'
import IMAGES from "../../const/Image";
import { useNavigate } from "react-router-dom";

const Logo = ({ collapsed }) => {
  const navigate = useNavigate();

  return (
    <div className={collapsed ? "logo logo1 shortlogo" : "logo logo1 longlogo"}>
      {collapsed ? (
        <img
          src={IMAGES.LogoShort?.src}
          className="cursor-pointer"
          alt="dfdfd"
          onClick={() => navigate("/")}
        />
      ) : (
        <span
          className="gradient-color-text cursor-pointer"
          onClick={() => navigate("/")}
        >
          BestBharat
        </span>
      )}
      {/* <img
        src={IMAGES.LogoHeader?.src}
        className="cursor-pointer"
        alt=""
        onClick={() => navigate("/")}
      /> */}
    </div>
  );
};

export default Logo;
